import { WebSocketReceiveMessage } from './web-socket-receive-message';
import { AssetTranscodeStatusUpdate } from '../../../image/dto/asset-transcode-status-update';
import { GenerateUploadUrlRequest } from '../../../image/requests/generate-upload-url-request';
import type { Asset } from '../../../image/dto/asset';

export class WebSocketAssetTranscodeStatusUpdate extends WebSocketReceiveMessage {
  override payload: AssetTranscodeStatusUpdate;

  override onDeserialize() {
    super.onDeserialize();
    this.payload = window?.injector?.Deserialize?.instanceOf(AssetTranscodeStatusUpdate, this.payload);
  }

  isFor(req: GenerateUploadUrlRequest): boolean {
    return this.payload?.isFor(req);
  }

  completed(): boolean {
    return this.payload?.completed();
  }

  errored(): boolean {
    return this.payload?.errored();
  }

  canceled(): boolean {
    return this.payload?.canceled();
  }

  getErrorMessage(): string {
    return this.payload?.errorMessage?.trim();
  }

  getAsset(): Asset | null {
    return this.payload?.asset;
  }

  hasAssetWithUniqueId(): boolean {
    return this.payload?.hasAssetWithUniqueId();
  }
}
